/** @typedef {'head' | 'headwear' | 'torso' | 'armLeft' | 'armRight' | 'legLeft' | 'legRight' | 'eyes'} PixelPersonPart */

/** @typedef {'hair' | 'skin' | 'eye' | 'eyeShine' | 'shirt' | 'shirtHighlight' | 'pants' | 'shoes' | 'outline' | 'headwear' | 'headwearAccent' | 'empty'} PixelPersonZone */

export const PIXEL_PERSON_PARTS = [
  'legLeft',
  'legRight',
  'torso',
  'armLeft',
  'armRight',
  'head',
  'headwear',
  'eyes',
];

/**
 * Assign each grid cell to a body part for layered SVG animation.
 * @param {number} rowIdx
 * @param {number} colIdx
 * @param {PixelPersonZone} zone
 * @returns {PixelPersonPart | null}
 */
export function resolvePixelPersonPart(rowIdx, colIdx, zone) {
  if (zone === 'empty') {
    return null;
  }
  if (zone === 'eye' || zone === 'eyeShine') {
    return 'eyes';
  }
  if (zone === 'headwear' || zone === 'headwearAccent') {
    return 'headwear';
  }

  if (rowIdx >= 14) {
    return colIdx <= 6 ? 'legLeft' : 'legRight';
  }

  if (rowIdx === 13) {
    if (colIdx <= 4) {
      return 'legLeft';
    }
    if (colIdx >= 9) {
      return 'legRight';
    }
    return 'torso';
  }

  if (rowIdx >= 10 && rowIdx <= 12) {
    if (colIdx <= 3) {
      return 'armLeft';
    }
    if (colIdx >= 10) {
      return 'armRight';
    }
    return 'torso';
  }

  if (rowIdx === 9) {
    return 'torso';
  }

  if (rowIdx <= 8) {
    return 'head';
  }

  return 'torso';
}

/** Transform origins per part — coordinates in 14×18 viewBox space. */
export const PIXEL_PERSON_PART_ORIGINS = {
  head: '7px 8px',
  headwear: '7px 6px',
  torso: '7px 11px',
  armLeft: '3px 10px',
  armRight: '10px 10px',
  legLeft: '4px 14px',
  legRight: '9px 14px',
  eyes: '7px 7px',
};
